import React from 'react'

const LogoSecondary = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 70 30" className="logo-secondary">
      <polygon className="logo-secondary-letter" points="70 5.99 60.7 5.99 60.7 11.98 69.44 11.98 69.44 18.02 60.7 18.02 60.7 24.01 70 24.01 70 30 55.23 30 55.23 0 70 0 70 5.99"/>
      <polygon className="logo-secondary-letter" points="44.58 29.96 44.58 30 39.16 30 39.12 29.96 32.28 0 37.74 0 41.87 18.02 45.96 0 51.42 0 44.58 29.96"/>
      <rect className="logo-secondary-letter" x="21.96" width="5.46" height="30" />
      <polygon className="logo-secondary-letter" points="16.39 30 10.93 30 10.93 18.02 5.46 18.02 5.46 30 0 30 0 0 5.46 0 5.46 11.98 10.93 11.98 10.93 0 16.39 0 16.39 30" />
    </svg>
  )
}

export default LogoSecondary


// WEBPACK FOOTER //
// ./src/assets/logo-secondary.js